import CurrencyEnum from '../Enum/CurrencyEnum'

// take the amount as argument and return with currency format
const currencyFormatterGBP = (amount) => {
  if (!amount && amount !== 0) {
    return ''
  }
  return `${CurrencyEnum.GBP} ${parseFloat(amount).toFixed(2)} `
}

export default currencyFormatterGBP
